import { includes } from "lodash";

import { GLOBAL_MODALS } from "../../config/modals";

const modalSlice = (set, _) => ({
  visible: null,

  showModal: (modal) => {
    if (includes(Object.keys(GLOBAL_MODALS), modal)) {
      set(state => ({ modal: {
        ...state.modal,
        visible: modal
      }}));
    }
  },

  closeModal: () => set(state => ({ modal: {
    ...state.modal,
    visible: null
  }})),

  isModalVisible: (modal) => visible === modal,
});

export default modalSlice;